import { useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "@/hooks";

import * as actions from "@/redux/LandingPageReducer";

const usePromoCode = ({ methods }) => {
  const dispatch = useAppDispatch();

  const { getValues, setError, setValue, clearErrors, handleSubmit } = methods;
  const [promoCodeButtonText, setPromoCodeButtonText] = useState("APPLY");
  const { goal, mobile, mobileCountryCode, promoCode } = getValues();

  const promoCodeCheckRequest = useCallback(
    (apiData) => dispatch(actions.promoCodeCheckRequest(apiData)),
    [dispatch]
  );

  const resetLandingPageData = useCallback(
    () => dispatch(actions.resetNutritionCallbackValues(goal, true)),
    [dispatch, goal]
  );

  const removePromoCode = useCallback(
    () => dispatch(actions.removePromoCode()),
    [dispatch]
  );

  const applyPromoCodeHelper = () => {
    if (promoCode) {
      const apiData = {
        coupon_code: promoCode?.toUpperCase(),
        slug: goal,
        mobile: mobile,
        phone_prefix: mobileCountryCode,
        is_hero_package: true,
      };

      promoCodeCheckRequest(apiData).then((payload) => {
        if (payload?.error) {
          setError("promoCode", { type: "custom", message: payload.error });
        } else {
          setPromoCodeButtonText("REMOVE");
        }
      });
    }
  };

  const applyPromoCode = handleSubmit(() => {
    clearErrors("promoCode");
    if (!promoCode) return;
    applyPromoCodeHelper();
  });

  const resetPromoCodeAppliedState = useCallback(() => {
    setValue("promoCode", "");
    clearErrors("promoCode");
    setPromoCodeButtonText("APPLY");
    removePromoCode();
  }, [removePromoCode, setValue, clearErrors]);

  const removeAppliedPromoCode = useCallback(() => {
    resetPromoCodeAppliedState();
    resetLandingPageData();
  }, [resetPromoCodeAppliedState, resetLandingPageData]);

  const handlePromoCodeChange = () => {
    clearErrors("promoCode");
    setPromoCodeButtonText("APPLY");
  };

  useEffect(() => {
    return () => removeAppliedPromoCode();
  }, []);

  return {
    promoCodeButtonText,
    applyPromoCode,
    handlePromoCodeChange,
    removeAppliedPromoCode,
  };
};

export default usePromoCode;
